import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-reload-error-modal',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './reload-error-modal.component.html',
  styleUrl: './reload-error-modal.component.scss'
})
export class ReloadErrorModalComponent {

  reload() {
    window.location.reload();
  }
}
